import * as React from "preact";
import { FunctionComponent, TargetedEvent } from "preact";

interface IToggle {
  label?: string;
  id?: string;
  checked?: boolean;
  name?: string;
  onChange: (e: TargetedEvent<HTMLInputElement, Event>) => void;
}

const Toggle: FunctionComponent<IToggle> = ({name, id, onChange, checked, label}) => {
  return <label
    className="toggle"
    htmlFor={id}>
    <div className="toggle__switch">
      <input type="checkbox"
             id={id}
             name={name}
             checked={checked}
             className="toggle__input"
             onChange={onChange}
             aria-labelledby={`${name}-label`}
      />
      <span className="toggle__slider"></span>
    </div>
    <span id={`${name}-label`} className="toggle__label">{label}</span>
  </label>
}

export default Toggle;
